import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_BANDITS_PSF_COMBO_EXPERIMENT = defineFcm('revenue_bandits_psf_combo_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
				exp_name_suffix: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
